// @flow
import styled from "styled-components";

export const Spinner = styled.div`
    height: 100vh;
    width: 100%;
    text-align: center;
    vertical-align: middle;
    line-height: 100vh;
`;



// WEBPACK FOOTER //
// ./src/photos-dialog/styled.js